import React, { memo, useRef } from 'react';
import { Typography } from 'fronton-react';
import { Section } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import { utpCard, utpCardsContainer, utpCardText } from './utp-cards-styles';

type UtpCardStructure = {
  title: string;
  text: string;
};

type UtpCardsProps = {
  elementBlock: string;
  cards: UtpCardStructure[];
};

export const UtpCards: React.FC<UtpCardsProps> = memo(({ elementBlock, cards }) => {
  const cardRefs = useRef<HTMLDivElement[]>([]);
  const promotions = cards.map(({ title }: UtpCardStructure, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  return (
    <Section className={utpCardsContainer}>
      {cards.map(({ title, text }, index) => (
        <div
          className={utpCard}
          data-position={index}
          key={createElementKey('t', index)}
          ref={(el: HTMLDivElement | null) => {
            if (el && cardRefs) cardRefs.current[index] = el;
          }}
        >
          <Typography variant="h2">{title}</Typography>
          <Typography className={utpCardText} variant="l" size="body_short">{text}</Typography>
        </div>
      ))}
    </Section>
  );
});
